<template>
  <d2-container>
    <template slot="header">
      <el-form
        :inline="true"
        :model="searchForm"
        ref="searchForm"
        size="mini"
        style="margin-bottom: -18px;"
      >
        <el-form-item
          label="公告标题"
          prop="noticeTitle"
        >
          <el-input
            v-model="searchForm.noticeTitle"
            placeholder="公告标题"
            style="width: 100px;"
          />
        </el-form-item>


        <el-form-item>
          <el-button
            type="primary"
            @click="handleSearchFormSubmit"
          >
            <d2-icon name="search" /> 查询
          </el-button>
        </el-form-item>

        <el-form-item>
          <el-button @click="handleSearchFormReset">
            <d2-icon name="refresh" /> 重置
          </el-button>
        </el-form-item>
      </el-form>
    </template>

    <el-table
      :data="tableData"
      v-loading="loading"
      size="small"
      stripe
      highlight-current-row
      style="width: 100%;"
      @selection-change="handleSelectionChange"
      @sort-change="handleSortChange"
    >

      <el-table-column
        type="selection"
        width="55"
      >
      </el-table-column>
      <el-table-column
        label="公告标题"
      >
        <template slot-scope="scope">
          {{scope.row.noticeTitle}}
        </template>
      </el-table-column>



      <el-table-column
        label="发布时间"
        prop="notice_time2"
        sortable="custom"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{scope.row.notice_time2}}
        </template>
      </el-table-column>
      <el-table-column
              label="通知对象"
              prop="noticeObject"
              sortable="custom"
              :show-overflow-tooltip="true"
              width="300"
      >
        <template slot-scope="scope">
            <span v-for="(item, index)  in scope.row.noticeObject" >
               <span v-if="item==0" >全国代理|</span>
               <span v-if="item==1" >运营商|</span>
               <span v-if="item==2" >服务商|</span>
               <span v-if="item==4" >商户|</span>
                <span v-if="item==5" >小程序用户|</span>
            </span>
        </template>
      </el-table-column>

      <el-table-column
        fixed="right"
        label="操作"
        align="center"
        width="300"
      >
          <template slot-scope="scope">
            <el-button type="primary" plain  size="mini"    @click="openEditForm(scope.row)">详情</el-button>


          </template>
      </el-table-column>

    </el-table>
    <template slot="footer">
      <el-pagination
        :current-page="page.current"
        :page-size="page.size"
        :total="page.total"
        :page-sizes="[1,10,50,100, 200, 300, 400]"
        layout="total, sizes, prev, pager, next, jumper"
        style="margin: -10px;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </template>
    <edit-form
      :agent="agent"
      :accuseVisible="accuseVisible"
      v-model="editFormVisible"
      @submit="getTableData"
    />

  </d2-container>
</template>
<script>
import * as noticeService from "@/api/sys/notice";
import editForm from "./editForm"
import util from '@/libs/util.js'
export default {
  name: "NoticePage",
  components: { editForm },
  data() {
    return {
      searchForm: {
          noticeTitle: ""
      },
        accuseVisible:true,
      loading: false,
      tableData: [],
      multipleSelection: [],
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      sort: {
        prop: "",
        order: ""
      },
        agent: {},
      editFormVisible: false
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    getTableData() {
      let query = {
        pageIndex: this.page.current,
        pageSize: this.page.size,
        sortBy: this.sort.prop,
          agentid: util.cookies.get('agentid'),
        dl_type: util.cookies.get('dl_type'),
        descending: this.sort.order === "descending",
        filter: this.searchForm
      };
        noticeService.getNoticePagedList(query).then(data => {
        this.tableData = data.rows;
        this.page.total = data.totalCount;
      });
    },
    handleSearchFormSubmit() {
      this.getTableData();
    },
    handleSearchFormReset() {
      this.$refs.searchForm.resetFields();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSortChange(val) {
      this.sort.prop = val.prop;
      this.sort.order = val.order;
      this.getTableData();
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.getTableData();
    },
    handleCurrentChange(val) {
      this.page.current = val;
      this.getTableData();
    },
    openEditForm(agent) {
          this.agent = agent;
          this.editFormVisible = true;
        this.accuseVisible=true;
      },
      openViewForm(agent) {
          this.agent = agent;
          this.editFormVisible = true;
          this.accuseVisible=false;
      },
      getImgUrl(row){
          return "https://hfqy-1315629620.cos.ap-chengdu.myqcloud.com/";
      },
    add() {
      this.agent = {};
      this.editFormVisible = true;
        this.accuseVisible=true;
    },
      batchDel() {
          this.$confirm("确认删除？", "确认信息", {
              distinguishCancelAndClose: true,
              confirmButtonText: "删除",
              cancelButtonText: "取消"
          }).then(() => {
              noticeService.delNotices({
                      ids: JSON.stringify(this.multipleSelection.map(s => s.noticeId))
                  })
                  .then(() => {
                      this.getTableData();
                  });
          });
      },
    del(noticeId) {
        let msg = "删除";
      this.$confirm("确认"+msg+"操作？", "确认信息", {
        distinguishCancelAndClose: true,
        confirmButtonText: msg,
        cancelButtonText: "取消"
      }).then(() => {
          noticeService.delNotice({noticeId:noticeId}).then(() => {
          this.getTableData();
        });
      });
    }
  }
};
</script>
